<template>
  <div>

    <b-navbar type="dark" variant="info" style="justify-content: space-between;">
      <b-navbar-brand>
        <img :src="require('@/assets/logo.png')" class="d-inline-block align-top" alt="logo" width="6%"
          height="6%" />
          线路人形监控系统
      </b-navbar-brand>


      <div class="right">
        <div v-if="role == '0'" style="padding: 0 50px 0 0;cursor: pointer; font-size: 18px;color: #fff;"
          @click="navigateToSettings">系统设置</div>
        <div v-if="role == '0'" style="padding: 0 50px 0 0;cursor: pointer; font-size: 18px;color: #fff;"
          @click="navigateToControl">监控点管理</div>
        <div style="cursor: pointer" @click="navigateToUser" v-if="role == '0'">
          <img :src="require('@/assets/user.png')" class="d-inline-block align-top" alt="logo" width="50px"
            height="50px" />
        </div>
        <div style="padding: 0 50px 0 50px;cursor: pointer; font-size: 18px;color: #fff;" @click="navigateToLogout">
          退出
        </div>
      </div>
    </b-navbar>

    <b-container fluid class="mt-2">
      <b-card no-body>
        <b-tabs card>
          <b-tab title="照片监控" :active="activeTab1" @click.stop="clickTab1">
            <image-list :getJumpItem="getJumpItem"></image-list>
          </b-tab>
          <b-tab title="照片信息" :active="activeTab2" @click.stop="clickTab2">
            <image-info :isSelected="isInfoSelected"></image-info>
          </b-tab>
        </b-tabs>
      </b-card>
    </b-container>
  </div>
</template>

<script>
// import StationStatus from '../components/StationStatus.vue'
// import WaterAlarm from '../components/WaterAlarm.vue'
import ImageList from '../components/ImageList.vue'
import ImageInfo from '../components/ImageInfo.vue'
// import UserControlVue from '../components/UserControl.vue';
// import WaterLinePage from '../components/WaterLinePage.vue';
// import WaterDaily from '../components/WaterDaily.vue';
// import DeviceSimManage from '../components/DeviceSimManage';
export default {
  name: 'Home',
  components: {
    // StationStatus,
    // WaterAlarm,
    ImageList,
    ImageInfo,
    // UserControlVue,
    // WaterLinePage,
    // WaterDaily
    // DeviceSimManage
  },
  created() {
    this.role = window.localStorage.getItem('role');
  },
  data() {
    return {
      show1: false,
      show2: false,
      show3: false,
      form1: {
        username: 'admin'
      },
      form2: {},
      form3: {},
      activeTab1: true,
      activeTab2: false,
      activeTab3: false,
      activeTab4: false,
      activeTab5: false,
      role: '',

      JumpItem: {
        stationUuid: 'all'
      },//用于跳转显示水位曲线的变量，未点击名称时为all

      isInfoSelected: false, // 用于表示image-info是否被选中
    };
  },
  methods: {
    handleOpenPassword() {
      this.activeTab1 = false;
      this.activeTab2 = false;
      this.activeTab3 = true;
    },
    clickTab1() {
      this.activeTab1 = true;
      this.activeTab2 = false;
      this.activeTab3 = false;
      this.activeTab4 = false;
      this.activeTab5 = false;
      this.isInfoSelected = false
    },
    clickTab2() {
      this.activeTab1 = false;
      this.activeTab2 = true;
      this.activeTab3 = false;
      this.activeTab4 = false;
      this.activeTab5 = false;
      this.isInfoSelected = true
    },
    clickTab3() {
      this.activeTab1 = false;
      this.activeTab2 = false;
      this.activeTab3 = true;
      this.activeTab4 = false;
      this.activeTab5 = false;
      this.isInfoSelected = false
    },
    clickTab4() {
      this.activeTab1 = false;
      this.activeTab2 = false;
      this.activeTab3 = false;
      this.activeTab4 = true;
      this.activeTab5 = false;
      this.isInfoSelected = false
    },
    clickTab5() {
      this.activeTab1 = false;
      this.activeTab2 = false;
      this.activeTab3 = false;
      this.activeTab4 = false;
      this.activeTab5 = true;
      this.isInfoSelected = false
    },
    navigateToUser() {
      this.$router.push({
        path: '/usermanage'
      })
    },
    navigateToControl() {
      this.$router.push({
        path: '/control'
      })
    },
    navigateToSettings() {
      this.$router.push({
        path: '/settings'
      })
    },
    //退出登录
    navigateToLogout() {

      this.boxTwo = ''
      this.$bvModal.msgBoxConfirm('是否退出登录?', {
        title: '请确认',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: '退出',
        cancelTitle: '取消',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
        .then(value => {
          this.boxTwo = value
          if (this.boxTwo) {
            window.localStorage.removeItem('username')
            window.localStorage.removeItem('password')
            window.localStorage.removeItem('role')
            window.localStorage.removeItem('token')
            this.$router.push({
              path: '/'
            })
          }
        })
        .catch(err => {
          // An error occurred
          console.log(err);
        })

    },

    getJumpItem(stationUuid) {
      this.JumpItem.stationUuid = stationUuid
      this.clickTab4();

    },
    resetJumpItem(stationUuid) {
      this.JumpItem.stationUuid = stationUuid

    }
  }
};

</script>

<style>
.right {
  padding-right: 10px;
  display: flex;
  align-items: center;
  font-size: 18px;
}

.has-submenu {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: right;
}

body {
  overflow-x: hidden;
}
</style>